import LocalizedStrings from 'react-localization';

let strings = new LocalizedStrings({
    en: {
        CustomerName: "Customer Name",
        ProductDetails: "Product Details",
        ProductName: "Product Name",
        Product: "Product",
        Quantity: "Quantity",
        UnitPrice: "Unit price",
        Quotation: "Quotation",
        SelectQuote: "Select Quotation",
        SelectProduct: "Select Product",
        Amount: "Amount",
        Price: "Price",
        Margin: "Margin",
        Generate: "Generate",
        Total: "Total",
        Actions: "Actions",
        AddProduct: "Add product",
        AddAdditionalCess: "Add Additional Details",
        ImportQuote: "Import Quotation",
        SelectCustomers: "Select customers",
        NoProductAddedToQuote: "No products added to Quotation",
        Select: "Select",
        Close: "Close",
        Save: "Save",
        Remarks: "Remarks",
        Validity: "Validity",
        Invalid: "Invalid",
        Address: "Address",
        PhoneNumber: "Phone Number",
        CustomerInformation: "Customer Information",
        TermsAndConditions: "Terms And Conditions",
        AdditionalQuotationDetails: "Additional Quotation Details",
        PleaseSelectCustomer: "Please Select a Customer",
        PleaseAddProduct: "Please add the Products.",
        InvalidQuotationDueDate: "Invalid Quotation Due Date.",
        PleaseSelectValidProduct: "Please select valid Product.",
        PleaseEnterValidQuantity: "Please enter valid Quantity.",
        PleaseEnterValidGST: "Please enter a valid GST.",
        PleaseEnterValidPrice: "Please enter a valid price.",
        PleaseEnterValidMargin: "Please enter a valid margin.",
        CanBeSmallerThan: "Cannot be less than"
    },
    de: {
        CustomerName: "Kundenname",
        ProductDetails: "Produkt Einzelheiten",
        ProductName: "Produktname",
        Product: "Produkt",
        Generate: "Generieren",
        SelectQuote: "Zitat auswählen",
        SelectProduct: "Ausgewähltes Produkt",
        Total: "gesamt",
        Quotation: "Zitat",
        UnitPrice: "Stückpreis",
        Quantity: "Quantität",
        Actions: "Aktionen",
        Amount: "Menge",
        Price: "Preis",
        Margin: "Spanne",
        AddProduct: "Produkt hinzufügen",
        AddAdditionalCess: "Fügen Sie zusätzliche hinzu Cess",
        ImportQuote: "Importieren Zitat",
        SelectCustomers: "Kunden auswählen",
        NoProductAddedToQuote: "Keine Produkte zum Zitat hinzugefügt",
        Select: "auswählen",
        Close: "schließen",
        Save: "speichern",
        Remarks: "Bemerkungen",
        Validity: "Gültigkeit",
        Invalid: "Ungültig",
        Address: "Adresse",
        PhoneNumber: "Telefonnummer",
        CustomerInformation: "Kundeninformation",
        TermsAndConditions: "Geschäftsbedingungen",
        AdditionalQuotationDetails: "Zusätzliche Zitat details",
        PleaseSelectCustomer: "Bitte wählen Sie einen Kunden aus",
        PleaseAddProduct: "Bitte fügen Sie die Produkte hinzu",
        InvalidQuotationDueDate: "ungültiges Zitatfälligkeitsdatum",
        PleaseSelectValidProduct: "Bitte wählen Sie ein gültiges Produkt aus.",
        PleaseEnterValidQuantity: "Bitte geben Sie eine gültige Menge ein.",
        PleaseEnterValidGST: "Bitte geben Sie eine gültige GST ein.",
        PleaseEnterValidPrice: "Bitte geben Sie einen gültigen Preis ein.",
        PleaseEnterValidMargin: "Please enter a valid margin.",
        CanBeSmallerThan: "Kann nicht kleiner sein als"
    }
});

export default strings;